import request, { ResponseData } from "../utils/request";
import { IChatRecvMessage, IChatSendMessage } from "../objects/chat/types";
import { PATH_PREFIX } from "../constants/request";
import i18next from "../i18n";
import { IGuessItem } from "../objects/guess/types";

const PREFIX = `${PATH_PREFIX}/richmodal/v1.0.2/generate_questions`;

const commonParams = {
  client_chan: "chatOnGuess",
  channel: "chat-web",
  area: i18next.language,
};

export async function getGuessList(params: {
  send_msg: IChatSendMessage[];
  recv_msg: IChatRecvMessage[];
  session_id: string;
}): Promise<ResponseData<{ list: IGuessItem[] }>> {
  // return new Promise((r, j) => {
  //   setTimeout(() => {
  //     r({
  //       "code": 0,
  //       "message": {
  //         "list": ["这是猜你想问的标题1", "这是猜你想问的标题2"],
  //       },
  //     });
  //   }, 2000);
  // });
  // return {
  //   "code": 0,
  //   "message": {
  //     "list": ["这是猜你想问的标题1", "这是猜你想问的标题2"],
  //   },
  // };
  return await request.post(`${PREFIX}`, {
    ...commonParams,
    ...params,
  });
}
